import React from 'react';
import { makeStyles } from 'tss-react/mui';
import Grid, { GridProps } from '@mui/material/Grid';

const useStyles = makeStyles()(() =>
  ({
    root: {
      display: 'flex',
      flexWrap: 'nowrap',
      margin: 0,
      width: '100%',
    },
  })
);

export function AreaContainer<C extends React.ElementType>(props: GridProps<C, { component?: C }>) {
  const { classes } = useStyles();
  const defaults = {
    className: classes.root,
    container: true,
    spacing: 2,
  };

  return <Grid {...{ ...defaults, ...props }} />;
}
